.list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.section-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m, $spacing-m);
  margin-top: var(--spacing-s, $spacing-s);
  padding-bottom: var(--spacing-l, $spacing-l);
}

.section-item-list {
  display: flex;
  flex-direction: column;
}

.section-wrapper {
  border-bottom: 1px solid var(--border-color-primary, border-color('primary'));
  padding-bottom: var(--spacing-m, $spacing-m);

  &:last-of-type {
    border-bottom: none;
  }
}

.section-title-wrapper {
  text-transform: capitalize;
  padding: var(--spacing-s, $spacing-s) var(--spacing-m, $spacing-m);

  * {
    color: var(--text-text-color-secondary, text-color('secondary'));
  }
}

.list-item {
  cursor: pointer;
}

.list-item-button {
  position: relative;
  text-decoration: none;
  display: flex;
  gap: var(--spacing-m, $spacing-m);
  align-items: center;
  padding: var(--spacing-m, $spacing-m);
  border-radius: var(--radius-s, $radius-s);
  background-color: var(--background-color-secondary, background-color('secondary'));
  border: 1px solid transparent;
  text-align: left;
  font-family: unset;
  cursor: pointer;
  transition: background-color 0.2s;

  @media (hover: hover) {
    &:hover {
      background-color: var(--background-color-tertiary, background-color('tertiary'));
    }
  }

  &:focus-visible {
    outline: none;
    border: 1px solid var(--border-color-accent, border-color('accent'));
  }
}

.collapsed {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-title {
  color: var(--text-color-primary, text-color('primary'));
}

.result-description {
  color: var(--text-color-tertiary, text-color('tertiary'));
}

.results-empty {
  text-align: center;
  width: 80%;
  max-width: pxToRem(400);
  margin: $spacing-2xl auto $spacing-3xl;
}

.suggestions-wrapper {
  padding: var(--spacing-l, $spacing-l) 0 var(--spacing-m, $spacing-m) 0;
}

.suggestions-title {
  text-transform: uppercase;
  margin-bottom: var(--spacing-xs, $spacing-xs);
  padding: 0 var(--spacing-s, $spacing-s);
}

.textWrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

ph-files {
  color: var(--icon-color-primary, icon-color('primary'));
}

.result-item-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.custom-result-item-icon {
  max-height: 20px;
  max-width: 20px;
  object-fit: contain;
}
